import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import DeleteDialog from '../../../components/delete-dialog'
import { addCategory, updateCategory, deleteCategory, listCategories } from '../../../actions/inventory.action'
import { getVendorList } from '../../../actions/vendor-management.action'
import CustomTable from '../../../components/table/table'
import SelectInput from '../../../components/inputs/select'
import CustomInput from '../../../components/inputs/new-input'
import TextAreaInput from '../../../components/inputs/textarea-input'
import { ValidateField, ValidatorTypes } from '../../../util/validators'
import { Modal } from 'react-bootstrap'
import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'

export default function AddCategory(props) {
  const dispatch = useDispatch();
  const permissions = useSelector(state => state.user.userData.permissions);
  const categoryList = useSelector(state => state.catalog.catalogs) || [];
  const { dialogClose, open, showList } = props
  const writePermission = permissions.catalog === 2 ? true : false
  const [name, setName] = useState('')
  const [VendorList, setVendorList] = useState([])
  const [VendorEditList, setVendorEditList] = useState([])
  const [description, setDescription] = useState('')
  const [nameError, setNameError] = useState(false)
  const [id, setCategoryId] = useState('')
  const [descriptionError, setDescriptionError] = useState(false)
  const [vendorError, setVendorError] = useState(false)
  const [list, setShowList] = useState((showList || true))
  const [deleteId, setDeleteId] = useState('')
  const [openDeleteHander, setOpenDeleteHander] = useState(false)
  const [vendorId, setVendorId] = useState(null)

  const changeHandler = e => {
    const { name, value } = e.target
    if (name === 'name') {
      setName(value)
      setNameError(false)
      const { error, valid } = ValidateField({ value: value, validation: [ValidatorTypes.REQUIRED] })
      if (!valid) setNameError(error)
    } else if (name === 'description') {
      setDescription(value)
      setDescriptionError(false)
      const { error, valid } = ValidateField({ value: value, validation: [ValidatorTypes.REQUIRED, ValidatorTypes.TEXTAREA] })
      if (!valid) setDescriptionError(error)
    }
    if (name === 'vendorId') {
      setVendorId(value)
      setVendorError(false)
      /* if (e.target.value.trim() === '') {
        setVendorError('This field is Required')
      } */
    }
  }
  useEffect(() => {
    fetchVendorList()
    fetchVendorEditList()
  }, [])

  useEffect(() => {
    if (categoryList.length === 0) dispatch(listCategories()).catch(e => console.log(e))
  }, []);

  const Categories = () => {
    return categoryList.map((Category, i) => ({
      ...Category,
      sno: i + 1,
      businessName: Category.vendor?.businessName
    }));
  }

  const fetchVendorList = async () => {
    const Vendors = []
    dispatch(getVendorList()).then((data) => {
      const all = JSON.parse(JSON.stringify(data))
      all && all.forEach(({ businessName, id }) => Vendors.push({ key: businessName, value: id }))
    })

    setVendorList(Vendors)
  }

  const fetchVendorEditList = async () => {
    const VendorsEdit = []
    dispatch(getVendorList('both')).then((data) => {
      const all = JSON.parse(JSON.stringify(data))
      all.forEach(vendor => {
        var vendorname = (vendor.isActive === false) ? vendor.businessName + " (Inactive)" : vendor.businessName;
        VendorsEdit.push({ key: vendorname, value: vendor.id })
      })
    })
    setVendorEditList(VendorsEdit)
  }
  const editCategory = (rowData) => {
    setShowList(false)
    setName(rowData.name || '')
    setDescription(rowData.description || '')
    setCategoryId(rowData.id || '')
    setVendorId(rowData.vendor_id || '')
  }

  const deleteHandler = (id) => {
    dispatch(deleteCategory({itemId: id})).then(res => {
      setOpenDeleteHander(false)
    })
  }

  const deleteDescription = () => {
    const categories = Categories();
    return categories.find(_ => _.id === deleteId)?.name || ''
  }

  const reset = () => {
    setName('')
    setDescription('')
    setCategoryId('')
    setShowList(true)
    setVendorId('')

  }

  const deleteDialogHandler = (id = '') => {
    setOpenDeleteHander(!openDeleteHander)
    setDeleteId(id)
  }

  const submitHandler = () => {
    // let valid = true
    const nameValidation = ValidateField({ value: name, validation: [ValidatorTypes.REQUIRED] })
    const descValidation = ValidateField({ value: description, validation: [ValidatorTypes.REQUIRED, ValidatorTypes.TEXTAREA] })
    if (!nameValidation.valid) setNameError(nameValidation.error)
    if (!descValidation.valid) setDescriptionError(descValidation.error)
    /* if (vendorId === '') {
      setVendorError('This field is Required')
      valid = false
    } */
    if (nameValidation.valid && descValidation.valid) {
      if (id === '') {
        dispatch(addCategory({ name, description, vendorId })).then(res => {
          reset()
        }).catch(e => console.error(e))
      } else {
        dispatch(updateCategory({ name, description, vendorId }, id)).then(res => {
          reset()
        }).catch(e => console.error(e))
      }
    }
  }

  const handleClose = () => {
    setShowList(true)
    setName('')
    setDescription('')
    setCategoryId('')
    setVendorId('')
    dialogClose()
  }

  const modalTitle = list ? 'Catalog List' : id === '' ? 'Create Catalog' : 'Update Catalog';

  return (
    <>
      <Modal
        show={open}
        onHide={handleClose}
        size='lg'
        centered
        dialogClassName="modal-70w create-modal"
        aria-labelledby="example-custom-modal-styling-title"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">{modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body className='pt-4'>
          {!list && <>
            <div className="purchase-order-block">
              <div className="row mb-4">
                <div className="col-lg-8">
                  <div className="row">
                    <div className="col-12 mt-3">
                      <CustomInput
                        name='name'
                        label='Catalog'
                        value={name}
                        error={nameError}
                        onChange={(e) => changeHandler(e)}
                      />
                    </div>

                    <div className="col-12 mt-3">
                      <SelectInput
                        name='vendorId'
                        label='Select Vendor'
                        items={id === '' ? VendorList : VendorEditList}
                        error={vendorError}
                        valid={!vendorError}
                        value={vendorId}
                        onChange={(e) => changeHandler(e)}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 mb-4">
                  <div className="mt-3">
                    <TextAreaInput
                      name='description'
                      label='Description'
                      error={descriptionError}
                      valid={!descriptionError}
                      value={description}
                      onChange={(e) => changeHandler(e)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </>
          }
          {list && <div className="purchase-order-block">
            <CustomTable
              columns={[
                { title: 'S No', field: 'sno' },
                { title: 'Catalog', field: 'name' },
                { title: 'Vendor', field: 'businessName' },
                { title: 'Description', field: 'description' },
              ]}
              data={Categories()}
              isEdit={writePermission}
              editHandler={editCategory}
              isDelete={writePermission}
              deleteHandler={(data) => deleteDialogHandler(data.id)}
              addButton={writePermission}
              addHandler={() => editCategory({})}
              fileName="Catalog List"
            />
          </div>}
        </Modal.Body>
        <Modal.Footer className='no-border p-0'>
          {!list && (
            <DialogActions className='actionbtn p-1'>
              <Button variant='contained' className='createBtn listbtn' color='primary' onClick={() => setShowList(true)}>List</Button>
              <div className='actionbtn'>
                <Button variant='contained' className='cancel-btn' color='primary' onClick={submitHandler}>Save</Button>
                <Button variant='contained' className='cancel-btn' color='warning' onClick={handleClose}>Cancel</Button>
              </div>
            </DialogActions>
          )}
        </Modal.Footer>
      </Modal>

      <DeleteDialog
        open={openDeleteHander}
        id={deleteId}
        deleteHandler={deleteHandler}
        dialogClose={deleteDialogHandler}
        moduleName='Category'
        description={deleteDescription()}
      />
    </>
  );
};
